<template>
  <div id="side-bar">
    <b-list-group flush class="no-border">
      <!-- :::::::::::::::::::::::::::: MENU RETORNAR SGCQ :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <img
          id="logo"
          class="m-2"
          :src="require('/static/images/logo_sgcq_w.png')"
          aria-label="Logomarca do SGCQ"
          width="130"
          @click="display()"
        />
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LIST :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <b-icon icon="slack" animation="spin" class="mr-3" /> Menu de Opções
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LISTA DE ORCAMENTOS :::::::::::::::::::::::::::: -->
      <b-list-group-item button class="menu-top" @click="limparOrcamento()">
        <b-icon icon="journal-plus" variant="info" class="mr-3" /> Novo Orçamento
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="listaDeOrcamentos()">
        <b-icon icon="file-ruled" variant="info" class="mr-3" /> Lista de Orçamentos
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU CONFIGURAÇÕES :::::::::::::::::::::::::::: -->
      <b-list-group-item v-b-toggle.modelo button class="menu-top">
        <b-icon icon="file-earmark-post-fill" class="mr-3" variant="info" />Modelo
      </b-list-group-item>
      <b-collapse id="modelo">
        <b-list-group>
          <b-list-group-item variant="secondary" button @click="setModelo('netech')">
            <b-icon variant="info" icon="card-heading" class="mr-3" />Netech
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="setModelo('netelog')">
            <b-icon variant="info" icon="card-heading" class="mr-3" />Netelog
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="setModelo('deb')">
            <b-icon variant="info" icon="card-heading" class="mr-3" />D&B
          </b-list-group-item>
        </b-list-group>
      </b-collapse>
      <!-- :::::::::::::::::::::::::::: MENU ADD ITEM :::::::::::::::::::::::::::: -->
      <b-list-group-item button class="menu-top" @click="addItem()">
        <b-icon icon="plus-circle" variant="info" class="mr-3" /> Adicionar Item
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="delItem()">
        <b-icon icon="dash-circle" variant="info" class="mr-3" /> Remover Item
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="listarProdutos()">
        <b-icon icon="box-seam" variant="info" class="mr-3" /> Adicionar Produto
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU OPCIONAL :::::::::::::::::::::::::::: -->
      <b-list-group-item button class="menu-top" @click="usarModelo()">
        <b-icon icon="files" variant="info" class="mr-3" /> Usar como Modelo
      </b-list-group-item>
      <b-list-group-item button class="menu-top" v-print="'#formularioDeOrcamento'">
        <b-icon icon="printer" variant="info" class="mr-3" /> Imprimir
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="salvar()">
        <b-icon icon="check2-circle" variant="info" class="mr-3" /> Salvar
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";

export default {
  name: "SideBarDoOrcamento",

  data() {
    return {};
  },

  methods: {
    limparOrcamento() {
      this.$emit("limparOrcamento");
    },

    listaDeOrcamentos() {
      this.$emit("listaDeOrcamentos");
    },

    addItem() {
      this.$emit("addItem");
    },

    delItem() {
      this.$emit("delItem");
    },

    listarProdutos() {
      this.$emit("listarProdutos");
    },

    usarModelo() {
      this.$emit("usarComoModelo");
    },

    salvar() {
      this.$emit("salvar");
    },

    setModelo(modelo) {
      this.$emit("setModelo", modelo);
    },

    display() {
      this.$router.push({ path: "/sgcq" });
    },
  },

  emits: ["setModelo"],

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped>
#side-bar {
  display: inline-block;
  width: 20%;
  height: 99vh;
  background-color: #112a4a;
  overflow: scroll;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  left: 0;
  text-align: start;
}

.menu-top {
  background-color: #112a4a;
  color: #fff;
  border: none;
}
</style>
